export default [];

export const DefaultPage = () => null;
export const ErrorPage = () => null;
